module.exports = __webpack_public_path__ + "static/sea-nature-beach-sand-112e5d87ce77ce6591a4756dbcedcfe7.png";